import {Box, Divider} from "@mui/material"
import React from "react"
import Content from "../../components/Content"

export const containerTableGridPrototype = [
    "gridconfiguration",
]

const ARRAYOFFSET = 1

const ContainerTableGrid = ({container}) => {
    const headerWidgets = container.children?.filter((entry) => entry.y === 0)
    const contentWIdgets = container.children?.filter((entry) => entry.y > 0)

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${container?.columncount}, 1fr)`,
                alignItems: "center",
                rowGap: "12px",
            }}>
            {headerWidgets?.map((widget) => (
                <Box
                    key={widget.id}
                    bgcolor={"#f8f9fa"}
                    height="100%"
                    sx={{
                        gridColumn: widget.x + 1 + " /span " + widget.w,
                        gridRow: widget.y + 1 + " /span " + widget.h,
                    }}>
                    <Content child={widget} />
                </Box>
            ))}
            <Divider
                sx={{
                    gridColumn: "1 / -1",
                    gridRow: 2,
                    mb: "12px",
                    bgcolor: "#3958D5",
                }}
            />

            {contentWIdgets?.map((widget) => (
                <Box
                    key={widget.id}
                    sx={{
                        gridColumn:
                            widget.x + ARRAYOFFSET + " /span " + widget.w,
                        gridRow:
                            widget.y + ARRAYOFFSET + 1 + " /span " + widget.h,
                    }}>
                    <Content
                        key={widget.i}
                        child={widget}
                    />
                </Box>
            ))}
        </Box>
    )
}

export default ContainerTableGrid
